import styled from 'styled-components';

import AirlineImg from 'components/AirlineLogo';
import List from 'components/List';
import ListItem from 'components/List/ListItem';

export const StyledList = styled(List)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Item = styled(ListItem)`
  height: 88px;
  padding: 40px 16px;
  justify-content: space-between;
  align-items: center;
`;

export const AirlineInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const AirlineLogo = styled(AirlineImg)`
  max-width: 26px;
  max-height: 26px;
  margin-right: 18px;
`;

export const AirlineName = styled.span``;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;
